import {
  EAuthorizedRepresentativeDecision,
  EDocumentKey,
  EI9AdminReviewStatus,
  EPublicI9Status,
} from "@zeal/common";
import { z } from "zod";

export const i9WebhookSchema = z.discriminatedUnion("status", [
  z.object({
    test: z.boolean(),
    companyID: z.string(),
    employeeID: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    status: z.literal(EPublicI9Status.STARTED),
    documents: z.array(z.nativeEnum(EDocumentKey)),
    business_name: z.string(),
  }),
  z.object({
    test: z.boolean(),
    companyID: z.string(),
    employeeID: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    status: z.literal(EPublicI9Status.SECTION_1_COMPLETED),
    admin_review_status: z.nativeEnum(EI9AdminReviewStatus).optional(),
    admin_review_by: z.string().optional(),
    documents: z.array(z.nativeEnum(EDocumentKey)),
    business_name: z.string(),
  }),
  z.object({
    test: z.boolean(),
    companyID: z.string(),
    employeeID: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    status: z.literal(EPublicI9Status.AUTHORIZED_REPRESENTATIVE_CONTACTED),
    admin_review_status: z.nativeEnum(EI9AdminReviewStatus).optional(),
    admin_review_by: z.string().optional(),
    authorized_representative: z.object({
      email: z.string().optional(),
      phone: z.string().optional(),
    }),
    documents: z.array(z.nativeEnum(EDocumentKey)),
    business_name: z.string(),
  }),
  z.object({
    test: z.boolean(),
    companyID: z.string(),
    employeeID: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    status: z.literal(EPublicI9Status.SECTION_2_COMPLETED),
    admin_review_status: z.nativeEnum(EI9AdminReviewStatus).optional(),
    admin_review_by: z.string().optional(),
    authorized_representative: z.object({
      first_name: z.string(),
      last_name: z.string(),
      email: z.string().optional(),
      phone: z.string().optional(),
      decision: z.nativeEnum(EAuthorizedRepresentativeDecision),
      decision_made_on: z.string(),
    }),
    documents: z.array(z.nativeEnum(EDocumentKey)),
    business_name: z.string(),
  }),
]);

export const i9WebhookRequestSchema = z.object({
  url: z.string(),
  testMode: z.boolean(),
});

export type TI9WebhookRequest = z.infer<typeof i9WebhookRequestSchema>;
export type TI9WebhookBody = z.infer<typeof i9WebhookSchema>;
